<template>
  <!-- 导航开始 -->
  <div class='lock clearfix'>
    <div class="ico">
      <i class="iconfont icon-quanxian"></i>
    </div>
    <h6>— 登陆超时或被锁定 —</h6>
    <hr>
    <div class="aa">
      <input class="form-control pwd style" type="password" autocomplete="new-password" v-model="pwd" :placeholder="localUser.user">
    </div>
    <div class="bb">
        <span @click="loginFun()" class="jiaobaio">
          <i v-if="isSearchLoading" class='iconfont icon-jiazai xuanzhuan'></i>
          解锁
        </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
// 引入通用common
import resultCommons from '@/util/resultcommons';
import rbacMix from '@/util/mix/localUserMix';
import { EventBus } from '@/util/eventBus';

export default {
  name: 'Lock',
  mixins: [rbacMix],
  data() {
    return {
      // 加载中
      isSearchLoading: false,
      pwd: '',
      user: '',
    };
  },
  computed: {
  },
  methods: {
    loginFun() {
      this.isSearchLoading = true;
      // 可以执行登录
      resultCommons.apiLogin(this, { user: this.user, pwd: this.pwd, isCheck: false, k: this.localUser.k, skip: false }).then((ob) => {
        this.isSearchLoading = false;
        if (ob.state === 200) {
          EventBus.$emit('homeTopbarinit', {});
        } else {
          // 失败
        }
      });
    },
  },
  components: {
  },
  created() {
    this.user = this.localUser.user;
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.lock{
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  background: #333239;
  justify-content: center;
  align-items: center;
  overflow: auto;
  .ico{
    i{
      font-size: 120px;
      color: #FF7D00;
    }
  }
  h6{
    margin-top: 60px;
    font-family: 'gilroy-regular';
  }
  div.aa{
    width: 300px;
    input{
      text-align: center;
      text-transform:capitalize;
    }
  }
  div.bb{
    width: 300px;
    margin-top: 20px;
    text-align: center;
    span{
      line-height: 2.6em;
      text-align: center;
      cursor: pointer;
      height: 38px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/lock.vue